import React, { useState, useMemo } from "react";
import {
  TableRow,
  TableCell,
  IconButton,
  Collapse,
  Box,
  Table,
  TableBody,
} from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { useSelector, useDispatch } from "react-redux";
import "./ExpandedTableRow.scss";
import { dataguard_icons } from "../../../components/common/utilities";
import { RenderUserName } from "../Utility/DetailsPopupConstant";
import { openDetailsPopup } from '../Popup/ActionCreator';
import { LOCATION, BEHAVIORMODEL, ACTIVE_USERS, ROLE_NAME, ROLES, OWNERID, DATA_ASSETS, PUBLIC_DATA, POLICY, POLICYID, COUNTRY, DATASOURCE, getHierarcyDataKey, ACTIVITIES, USERS, ANOMALIES, ASSETS, OPEN_ANOMALIES } from '../Popup/ActionTypes';
import { formatNumber } from "../Utility/DataguardConstant";
import SeverityChips from "../DataGuardCommonComponents";
import { renderDonutChart } from "./config/pageConfigurations";

const ExpandableTableRow = ({ row, columns, selectedCategory }) => {
  const [open, setOpen] = useState(false);
  const isIncognito = useSelector((state) => state.DataguardReducer.incognito);

  // Extract widths from columns configuration and prepare activeColumns for expanded table
  const firstColumnWidth = columns[0]?.width;
  const dispatch = useDispatch();
  const openPopup = (props) => {
    dispatch(
      openDetailsPopup(props)
    );
  };

  // Define which fields to show per category, with widths from pageConfigurations
  const categoryColumns = {
    locations: [
      { key: "usersCount", label: "Users", id: "usersAccumulated", width: columns.find(col => col.id === "usersAccumulated")?.width },
      { key: "anomalyCount", chartType: "pie", label: "Anomaly", id: "anomalyAccumulated", width: columns.find(col => col.id === "anomalyAccumulated")?.width },
      { key: "activitiesCount", label: "Activities", id: "activitiesAccumulated", width: columns.find(col => col.id === "activitiesAccumulated")?.width },
      { key: "dataAssetsCount", label: "Data Assets", id: "uniqueDataAssetsAccumulated", width: columns.find(col => col.id === "uniqueDataAssetsAccumulated")?.width },
    ],
    roles: [
      { key: "usersCount", label: "Users", id: "users", width: columns.find(col => col.id === "users")?.width },
      { key: "activeUsersCount", label: "Active Users", id: "activeUsersAccumulated", width: columns.find(col => col.id === "activeUsersAccumulated")?.width },
      { key: "dummy1", isdummy: true, label: "", id: "percentageOfTotalUsers", width: columns.find(col => col.id === "percentageOfTotalUsers")?.width },
      { key: "anomaliesCount", label: "Anomalies", chartType: "pie", id: "anomaliesAccumulated", width: columns.find(col => col.id === "anomaliesAccumulated")?.width },
      { key: "dummy2", isdummy: true, label: "", id: "locations", width: columns.find(col => col.id === "locations")?.width },
    ],
    publicdata: [
      { key: "assetsCount", label: "Public Assets", id: "assetsAccumulated", width: columns.find(col => col.id === "assetsAccumulated")?.width },
      { key: "activitiesCount", label: "Activities", id: "activitiesAccumulated", width: columns.find(col => col.id === "activitiesAccumulated")?.width },
      { key: "dummy1", isdummy: true, label: "", id: "locations", width: columns.find(col => col.id === "locations")?.width },
      { key: "dummy2", isdummy: true, label: "", id: "action", width: columns.find(col => col.id === "action")?.width },
    ],
    behaviormodels: [
      { key: "usersCount", label: "Users", id: "users", width: columns.find(col => col.id === "users")?.width },
      { key: "totalAnomaliesCount", chartType: "pie", label: "Total Anomalies", id: "totalAnomaliesByDs", width: columns.find(col => col.id === "totalAnomaliesByDs")?.width },
      { key: "severity", label: "Severity", id: "severity", width: columns.find(col => col.id === "severity")?.width },
      { key: "dummy2", isdummy: true, label: "", id: "action", width: columns.find(col => col.id === "action")?.width },
    ],

  };

  const activeColumns = categoryColumns[selectedCategory] || [];
  const getOpenCloseAnomaliesCount = (row, dsId) => {
    const anomaliesList = (selectedCategory === "roles") ? row.anomalies : row.anomaly;
    const selectedDS = anomaliesList.find((an) => an.dataSourceId === dsId);
    return {
      open: selectedDS?.Unresolved || 0,
      close: selectedDS?.totalAnomaliesCount - selectedDS?.Unresolved || 0,
    };
  };
  const getMapData = (row, dsId) => {
    console.log(row, dsId);
    return [];
  };

  // Build per data source row from accumulated values
  const perDsData = useMemo(() => {
    const dsMap = {};
    let allDsIds = new Set();

    // Collect all relevant datasource IDs for each category
    switch (selectedCategory) {
      case "behaviormodels":
        allDsIds = new Set([
          ...Object.keys(row.users || {}),
          ...Object.keys(row.totalAnomaliesByDs || {}),
          ...Object.keys(row.openAnomalies || {}),
        ]);
        break;
      case "roles":
        allDsIds = new Set([
          ...Object.keys(row.usersAccumulated || {}),
          ...Object.keys(row.anomaliesAccumulated || {}),
          ...Object.keys(row.activeUsersAccumulated || {}),
        ]);
        break;
      case "publicdata":
        allDsIds = new Set([
          ...Object.keys(row.assetsAccumulated || {}),
          ...Object.keys(row.activitiesAccumulated || {}),
        ]);
        break;
      case "locations":
        allDsIds = new Set([
          ...Object.keys(row.usersAccumulated || {}),
          ...Object.keys(row.anomalyAccumulated || {}),
          ...Object.keys(row.activitiesAccumulated || {}),
          ...Object.keys(row.uniqueDataAssetsAccumulated || {}),
        ]);
        break;
      default:
        allDsIds = new Set();
    }

    allDsIds.forEach((dsId) => {
      const dsMeta =
        row.users?.[dsId] ||
        row.totalAnomaliesByDs?.[dsId] ||
        row.openAnomalies?.[dsId] ||
        row.usersAccumulated?.[dsId] ||
        row.anomaliesAccumulated?.[dsId] ||
        row.activeUsersAccumulated?.[dsId] ||
        row.activitiesAccumulated?.[dsId] ||
        row.uniqueDataAssetsAccumulated?.[dsId] ||
        row.assetsAccumulated?.[dsId] ||
        row.publicAssetAccessCountPerDs?.[dsId] ||
        {};

      if (selectedCategory === "locations") {
        dsMap[dsId] = {
          dataSourceId: dsId,
          dataSourceName: dsMeta.dataSourceName || "-",
          dataSourceType: dsMeta.dataSourceType || "-",
          usersCount: row.usersAccumulated?.[dsId] ?? "-",
          anomalyCount: row.anomalyAccumulated?.[dsId] ?? "-",
          activitiesCount: row.activitiesAccumulated?.[dsId] ?? "-",
          dataAssetsCount: row.uniqueDataAssetsAccumulated?.[dsId] ?? "-",
          openCloseAnomaliesCount: getOpenCloseAnomaliesCount(row, dsId),
          mapData: getMapData(row, dsId),
        };
      } else if (selectedCategory === "roles") {
        dsMap[dsId] = {
          dataSourceId: dsId,
          dataSourceName: dsMeta.dataSourceName || "-",
          dataSourceType: dsMeta.dataSourceType || "-",
          usersCount: row.usersAccumulated?.[dsId] ?? "-",
          anomaliesCount: row.anomaliesAccumulated?.[dsId] ?? "-",
          activeUsersCount: row.activeUsersAccumulated?.[dsId] ?? "-",
          openCloseAnomaliesCount: getOpenCloseAnomaliesCount(row, dsId)
        };
      } else if (selectedCategory === "publicdata") {
        dsMap[dsId] = {
          dataSourceId: dsId,
          dataSourceName: dsMeta.dataSourceName || "-",
          dataSourceType: dsMeta.dataSourceType || "-",
          assetsCount: row.assetsAccumulated?.[dsId] ?? "-",
          activitiesCount: row.activitiesAccumulated?.[dsId] ?? "-",
        };
      } else if (selectedCategory === "behaviormodels") {
        dsMap[dsId] = {
          dataSourceId: dsId,
          dataSourceName: dsMeta.dataSourceName || "-",
          dataSourceType: dsMeta.dataSourceType || "-",
          usersCount: row.users?.[dsId]?.count ?? 0,
          totalAnomaliesCount: row.totalAnomaliesByDs?.[dsId]?.count ?? 0,
          openAnomaliesCount: row.openAnomalies?.[dsId]?.count ?? 0,
          highCount: row.totalAnomaliesByDs?.[dsId]?.high ?? 0,
          mediumCount: row.totalAnomaliesByDs?.[dsId]?.medium ?? 0,
          lowCount: row.totalAnomaliesByDs?.[dsId]?.low ?? 0,
        };
      }

    });

    return Object.values(dsMap);
  }, [row, selectedCategory]);

  const onCellClick = (e, row, col, item) => {
    const detailsPageName = selectedCategory;
    switch (detailsPageName.toLowerCase()) {
      case "locations":
        if (col.id === "activitiesAccumulated") {
          const props = {
            hierarchy: [LOCATION, COUNTRY, DATASOURCE, ACTIVITIES],
            subtitleDisplayName: row.location,
            [getHierarcyDataKey(COUNTRY)]: row.location,
            [getHierarcyDataKey(DATASOURCE)]: item ? item.dataSourceId : perDsData[0]?.dataSourceId,
          }
          openPopup(props);
        } else if (col.id === "usersAccumulated") {
          const props = {
            hierarchy: [LOCATION, COUNTRY, DATASOURCE, USERS],
            subtitleDisplayName: row.location,
            [getHierarcyDataKey(COUNTRY)]: row.location,
            [getHierarcyDataKey(DATASOURCE)]: item ? item.dataSourceId : perDsData[0]?.dataSourceId,
          }
          openPopup(props);
        } else if (col.id === "anomalyAccumulated") {
          const props = {
            hierarchy: [LOCATION, COUNTRY, DATASOURCE, ANOMALIES],
            subtitleDisplayName: row.location,
            [getHierarcyDataKey(COUNTRY)]: row.location,
            [getHierarcyDataKey(DATASOURCE)]: item ? item.dataSourceId : perDsData[0]?.dataSourceId,
          }
          openPopup(props);
        } else if (col.id === "uniqueDataAssetsAccumulated") {
          const props = {
            hierarchy: [LOCATION, COUNTRY, DATASOURCE, ASSETS],
            subtitleDisplayName: row.location,
            [getHierarcyDataKey(COUNTRY)]: row.location,
            [getHierarcyDataKey(DATASOURCE)]: item ? item.dataSourceId : perDsData[0]?.dataSourceId,
          }
          openPopup(props);
        }
        break;
      case "behaviormodels":
        if (col.id === "users") {
          const props = {
            hierarchy: [BEHAVIORMODEL, POLICY, DATASOURCE, USERS],
            subtitleDisplayName: row.policyName,
            [getHierarcyDataKey(POLICYID)]: row.policyId,
            [getHierarcyDataKey(DATASOURCE)]: item ? item.dataSourceId : perDsData[0]?.dataSourceId,
          }
          openPopup(props);
        } else if (col.id === "totalAnomaliesByDs") {
          const props = {
            hierarchy: [BEHAVIORMODEL, POLICY, DATASOURCE, ANOMALIES],
            subtitleDisplayName: row.policyName,
            [getHierarcyDataKey(POLICYID)]: row.policyId,
            [getHierarcyDataKey(DATASOURCE)]: item ? item.dataSourceId : perDsData[0]?.dataSourceId,
          }
          openPopup(props);
        } else if (col.id === "severity") {
          const props = {
            hierarchy: [BEHAVIORMODEL, POLICY, DATASOURCE, OPEN_ANOMALIES],
            subtitleDisplayName: row.policyName,
            [getHierarcyDataKey(POLICYID)]: row.policyId,
            [getHierarcyDataKey(DATASOURCE)]: item ? item.dataSourceId : perDsData[0]?.dataSourceId,
          }
          openPopup(props);
        }
        break;
      case "publicdata":
        if (col.id === "assetsAccumulated") {
          const props = {
            hierarchy: [PUBLIC_DATA, ASSETS, DATASOURCE, DATA_ASSETS],
            subtitleDisplayName: RenderUserName({ value: row.ownerName }, isIncognito),
            [getHierarcyDataKey(OWNERID)]: row.ownerId,
            [getHierarcyDataKey(DATASOURCE)]: item ? item.dataSourceId : perDsData[0]?.dataSourceId,
          }
          openPopup(props);
        } else if (col.id === "activitiesAccumulated") {
          const props = {
            hierarchy: [PUBLIC_DATA, ASSETS, DATASOURCE, ACTIVITIES],
            subtitleDisplayName: RenderUserName({ value: row.ownerName }, isIncognito),
            [getHierarcyDataKey(OWNERID)]: row.ownerId,
            [getHierarcyDataKey(DATASOURCE)]: item ? item.dataSourceId : perDsData[0]?.dataSourceId,
          }
          openPopup(props);
        } else if (col.id === "locations") {
          const country = e?.target?.title || "";
          if (!country) return;
          const props = {
            hierarchy: [PUBLIC_DATA, ASSETS, DATASOURCE, COUNTRY],
            [getHierarcyDataKey(OWNERID)]: row.ownerId,
            subtitleDisplayName: RenderUserName({ value: row.ownerName }, isIncognito),
            [getHierarcyDataKey(DATASOURCE)]: item ? item.dataSourceId : perDsData[0]?.dataSourceId,
            [getHierarcyDataKey(COUNTRY)]: country,
          }
          openPopup(props);
        }
        break;
      case "roles":
        if (col.id === "users" || col.id === "percentageOfTotalUsers") {
          const props = {
            hierarchy: [ROLES, DATASOURCE, USERS],
            subtitleDisplayName: row.roleName,
            [getHierarcyDataKey(ROLE_NAME)]: row.roleName,
            [getHierarcyDataKey(DATASOURCE)]: item ? item.dataSourceId : perDsData[0]?.dataSourceId,
          }
          openPopup(props);
        } else if (col.id === "activeUsersAccumulated") {
          const props = {
            hierarchy: [ROLES, DATASOURCE, ACTIVE_USERS],
            subtitleDisplayName: row.roleName,
            [getHierarcyDataKey(ROLE_NAME)]: row.roleName,
            [getHierarcyDataKey(DATASOURCE)]: item ? item.dataSourceId : perDsData[0]?.dataSourceId,
          }
          openPopup(props);
        } else if (col.id === "anomaliesAccumulated") {
          const props = {
            hierarchy: [ROLES, DATASOURCE, ANOMALIES],
            subtitleDisplayName: row.roleName,
            [getHierarcyDataKey(ROLE_NAME)]: row.roleName,
            [getHierarcyDataKey(DATASOURCE)]: item ? item.dataSourceId : perDsData[0]?.dataSourceId,
          }
          openPopup(props);
        } else if (col.id === "locations") {
          const country = e?.target?.title || "";
          if (!country) return;
          const props = {
            hierarchy: [ROLES, DATASOURCE, COUNTRY],
            subtitleDisplayName: row.roleName,
            [getHierarcyDataKey(ROLE_NAME)]: row.roleName,
            [getHierarcyDataKey(DATASOURCE)]: item ? item.dataSourceId : perDsData[0]?.dataSourceId,
            [getHierarcyDataKey(COUNTRY)]: country,
          }
          openPopup(props);
        }
        break;
      default:
        break;
    }
  };

  const handleRowClick = (e, dsId = null, mapData = null) => {
    if (perDsData.length > 1) {
      setOpen(!open);
      return;
    }
  };

  const renderPieChart = (item) => {
    console.log(selectedCategory);
    console.log(item);
    if (selectedCategory === "roles" || selectedCategory === "locations") {
      const valueArr = [
        { count: item.openCloseAnomaliesCount?.close || 0,
          name: "Closed Anomalies",
        },
        {
          count: item.openCloseAnomaliesCount?.open || 0,
          name: "Open Anomalies",
        },
      ];
      return renderDonutChart(valueArr, true);
    } else {
      const valueArr = [
        { count: item.totalAnomaliesCount - item.openAnomaliesCount,
          name: "Closed Anomalies",
        },
        {
          count: item.openAnomaliesCount,
          name: "Open Anomalies",
        },
      ];
      return renderDonutChart(valueArr, true);
    }
  }

  const renderAnomalies = (val, extraClass, col, item) => {
    if (col.chartType === "pie") {
      return renderPieChart(item);
    } else {
      return <Chip
        size="medium"
        label={val}
        color="primary"
        className={`user-chip numberValues ${extraClass}`}
      />
    }
  }

  return (
    <>
      {/* Main Row */}
      <TableRow className="clickable-table-row" onClick={handleRowClick}>
        {columns.map((column) => (
          <TableCell
            style={{
              ...column.customStyles,
              width: column.width,
            }}
            align={column.align || "center"}
            key={column.id}
            onClick={(e) => { return perDsData.length === 1 && onCellClick(e, row, column); }}
          >
            {column.renderCell
              ? column.renderCell(row[column.id], isIncognito)
              : row[column.id]}
          </TableCell>
        ))}

        {/* Toggle Expand */}
        <TableCell padding="checkbox">
          {perDsData.length > 1 && (
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                setOpen(!open);
              }}
              style={{
                background: "#e5e9ff",
                borderRadius: 5,
                color: "#535458",
              }}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell>
      </TableRow>

      {/* Collapsible Row */}
      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0, padding: 0 }}
          colSpan={columns.length + 1}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box className="expandable-row-details">
              <Table
                className="accordion-inner-table"
                style={{ width: "100%", tableLayout: "fixed" }}
              >
                <TableBody>
                  {perDsData.map((item, idx) => (
                    <TableRow
                      key={idx}
                      className="clickable-table-row"
                      onClick={(e) =>
                        handleRowClick(e, item.dataSourceId, item.mapData)
                      }
                    >
                      {/* always show datasource name */}
                      <TableCell
                        align="left"
                        style={{ width: firstColumnWidth }}
                      >
                        <div className="data-guard-accordion-type first-col-sub-accord">
                          <div>{item.dataSourceName}</div>
                          <img
                            style={{
                              width: "25px",
                            }}
                            title={item.dataSource}
                            src={dataguard_icons[item.dataSourceType]}
                            alt={item.dataSourceType}
                          />
                        </div>
                      </TableCell>

                      {/* render only relevant columns for this category */}
                      {activeColumns.map((col) => {
                        if (
                          col.key === "severity" &&
                          selectedCategory === "behaviormodels"
                        ) {
                          // Render SeverityChips for the severity column
                          return (
                            <TableCell
                              key={col.key}
                              align="center"
                              style={{
                                width: col.width,
                                overflow: "hidden",
                                whiteSpace: "normal",
                                textOverflow: "ellipsis",
                                wordWrap: "break-word",
                              }}
                            >
                              <SeverityChips
                                  high={item.highCount}
                                  medium={item.mediumCount}
                                  low={item.lowCount}
                                />
                            </TableCell>
                          );
                        }
                        let extraClass = "",
                          val = 0;
                        val =
                          typeof item[col.key] === "object"
                            ? formatNumber(item[col.key].count)
                            : formatNumber(item[col.key]);
                        if (
                          [
                            "anomalyCount",
                            "anomaliesCount",
                            "totalAnomaliesCount",
                          ].includes(col.key)
                        ) {
                          if (val === "0" || val === 0) {
                            extraClass = "success";
                          } else {
                            extraClass = "error";
                          }
                        }
                        return (
                          <TableCell
                            key={col.key}
                            align="center"
                            style={{
                              width: col.width,
                              whiteSpace: "normal",
                              textOverflow: "ellipsis",
                              wordWrap: "break-word",
                            }}
                            onClick={(e) => { e.stopPropagation(); onCellClick(e, row, col, item); }}
                          >
                            {!col.isdummy ? (
                              renderAnomalies(val, extraClass, col, item)
                            ) : (
                              "-"
                            )}
                          </TableCell>
                        );
                      })}

                      {/* Add dummy cells for missing parent columns to match width calculations */}
                      {columns
                        .slice(1, columns.length - activeColumns.length)
                        .map((column) => (
                          <TableCell
                            key={`dummy-${column.id}`}
                            style={{ width: column.width }}
                          ></TableCell>
                        ))}

                      {/* Dummy Toggle Expand */}
                      <TableCell padding="checkbox"></TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default ExpandableTableRow;
